import React, { useState } from 'react';
import './logic/login.css';
import logo from '../../components/assets/logo.webp';
import useLogin from './logic/useLogin';
//import { useAlert } from '../../utils';

import { showGlobalAlert } from '../../utils/globalAlert';
const Login = () => {
    const { username, setUsername, password, setPassword, handleLogin } = useLogin();
    const [isLoading, setIsLoading] = useState(false);
  //  const { messagerRef, showAlert } = useAlert(); // Menggunakan hook useAlert
     

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const result = await handleLogin(e);
        setIsLoading(false);
        console.log('result', result);
        if (result.status === 0) {
            //showAlert("Error", "error", result.message);
            showGlobalAlert('Danger', 'info', result.message);
        } else {
            //showAlert("Success", "info", "Login successful!");
            //showGlobalAlert('Success', 'info', 'Your data has been saved successfully!');
            //Navigate('/dashboard', { state: { result } });
        }
    };

    return (
        <div className="login-container">
            <div className="logo-section">
                <div className="brand-panel">
                    <img src={logo} alt="Company Logo" className="logo" />
                    <div className="brand-copy">
                        <p className="brand-eyebrow">Lemo Crane System</p>
                        {/* <h1>Control center for your daily operation.</h1> */}
                        <p>Secure access for monitoring, administration, and reporting.</p>
                    </div>
                </div>
            </div>
            <div className="login-form-section">
                <div className="login-window">
                    <div className="title-bar">
                        <span>Welcome</span>
                    </div>
                    <form className="login-form" onSubmit={onSubmit}>
                        <div className="form-heading">
                            <h2>Sign in</h2>
                            <p>Enter your account details to continue.</p>
                        </div>
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                required
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                required
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        {isLoading && <div className="loading-bar"></div>}
                        <div className="button-group">
                            <button type="submit" className="ok-button" disabled={isLoading}>
                                {isLoading ? 'Signing in...' : 'Sign in'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
